export default function getFileExtension(file: File): string {
  const type = file.type.toLowerCase();
  if (type.includes("gif")) {
    return "gif";
  }

  // Default
  return "png";
}
